import styled, { createGlobalStyle } from 'styled-components';

export const Global = createGlobalStyle<{ blue?: string }>`
  :root {
    --blue: ${({ blue }) => blue ?? '#00d25c'};
    --bg: #f6f6f6;
    --card: #ffffff;
    --border: #e6e7eb;
    --text: #1d1f23;
    --muted: #6d6e78;
    --danger: #e01b1b;
    --success: #00d25c;
    --paypal-gold: #FFC439; /* padrão PayPal */
    --applepay-black: #000000;
    --radius: 10px;
    --radius-sm: 6px;
  }

  * {
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    margin: 0;
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
    color: var(--text);
    background: var(--bg);
  }

  img {
    max-width: 100%;
    display: block;
  }

  button {
    font-family: inherit;
  }
`;

export const Page = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  max-width: 720px;
  width: 100%;
  padding: 16px;
  margin: 0 auto 80px auto;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 380px) {
    padding: 10px;
    gap: 14px;
  }
`;

export const Footer = styled.div`
  text-align: left;
  color: var(--muted);
  margin-top: 16px;
  font-size: 13px;

  img.safe {
    height: 22px;
    margin-right: 6px;
    display: inline-block;
  }
`;
